// extracted by mini-css-extract-plugin
export var cell = "cell-module--cell--3b6df";
export var nowrap = "cell-module--nowrap--132da";